import React, { useRef, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from '~/lib/bn-material-ui';
import { entityStore, sirenActions } from '~/utility/BinSentry-ui-utility';
import NoDevice from './banners/no-device';

const useStyles = makeStyles(() => {
  return {
    center: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    saveError: {
      fontWeight: 'bolder',
    },
  };
});

export default function Initialize({ action, href }) {
  const styles = useStyles();
  const [saveError, setSaveError] = useState('');
  const [showError, setShowError] = useState(false);
  const dialogContainer = useRef();

  if (!action) {
    return (
      <>
        <NoDevice />
        <div className={styles.center}>
          <p>This bin has not yet been configured.</p>
        </div>
      </>
    );
  }

  const submit = async (value) => {
    const fields = sirenActions.getActionFields(action);
    fields.set('monitoringType', value);
    try {
      await sirenActions.submitAction(action, fields);
      entityStore.invalidateHref(href);
    } catch (e) {
      if (e.code !== 422) {
        throw e;
      }
      setSaveError(e.message);
      setShowError(true);
    }
  };
  const onClose = () => setShowError(false);
  return (
    <>
      <NoDevice />
      <div className={styles.center}>
        <Button variant='outlined' onClick={() => submit('monitored')}>
          Request Device Installation
        </Button>

        <p>or</p>

        <Button variant='outlined' onClick={() => submit('unmonitored')}>
          Configure as a Standard Bin
        </Button>
      </div>

      <div ref={dialogContainer} />
      <Dialog
        open={showError}
        onClose={onClose}
        container={dialogContainer.current}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>{saveError}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
